<div id="science-labs" class="inner-page py-5">
  <div class="container-fluid px-lg-5">
    <h2 class="title text-uppercase mb-2">Science Laboratories</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College is committed to practical, experiential learning. Our science laboratories are equipped with modern instruments, safety features, and robust infrastructure to foster logical thinking, analysis, and discovery.
    </p>

    <hr class="divider">

    <!-- Interactive Folder / Gallery Sections -->
    <div class="gallery-section mt-4">
      <h3 class="gallery-title text-center mb-4">Select a Science Wing</h3>
      
      <!-- Folders Navigation -->
      <div class="d-flex justify-content-center gap-3 mb-5 flex-wrap">
        <button class="btn btn-folder" [class.active]="activeTab === 'physics'" (click)="setActiveTab('physics')">
          <i class="fas fa-folder-open me-2"></i> Physics Laboratory
        </button>
        <button class="btn btn-folder" [class.active]="activeTab === 'chemistry'" (click)="setActiveTab('chemistry')">
          <i class="fas fa-folder-open me-2"></i> Chemistry Laboratory
        </button>
        <button class="btn btn-folder" [class.active]="activeTab === 'homescience'" (click)="setActiveTab('homescience')">
          <i class="fas fa-folder-open me-2"></i> Home Science Laboratory
        </button>
      </div>

      <!-- Physics Lab Panel -->
      <div *ngIf="activeTab === 'physics'" class="animate-fade-in">
        <div class="row g-4 mb-4 align-items-center">
          <div class="col-lg-12">
            <h4 class="section-subtitle text-success mb-3">Physics Laboratory Infrastructure</h4>
            <p class="inner-lead">
              The Physics Lab is designed to meet the highest standards of accuracy and efficiency. It is equipped with advanced optical benches, electromagnetic apparatus, mechanical wave setups, and precision meters. Students perform detailed experiments in mechanics, thermodynamics, acoustics, optics, and electronics under expert mentorship.
            </p>
          </div>
        </div>
        <div class="row g-3 justify-content-center">
          <div class="col-6 col-sm-4 col-md-3" *ngFor="let img of physicsImages">
            <div class="gallery-card rounded-4 overflow-hidden position-relative shadow-sm" (click)="openLightbox(img)">
              <img [src]="img" alt="Physics Lab Apparatus" class="img-fluid w-100" style="object-fit: cover; height: 180px; transition: transform 0.3s ease;">
              <div class="gallery-overlay d-flex align-items-center justify-content-center">
                <span class="zoom-icon"><i class="fas fa-search-plus"></i> View</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Chemistry Lab Panel -->
      <div *ngIf="activeTab === 'chemistry'" class="animate-fade-in">
        <div class="row g-4 mb-4 align-items-center">
          <div class="col-lg-12">
            <h4 class="section-subtitle text-success mb-3">Chemistry Laboratory Infrastructure</h4>
            <p class="inner-lead">
              The Chemistry Lab features state-of-the-art apparatus for organic, inorganic, and physical chemistry analysis. Equipped with fume hoods, digital balances, titration counters, and safety gear, it provides a safe, highly efficient workspace. Rigorous safety protocols are followed to ensure students can perform chemical experiments securely.
            </p>
          </div>
        </div>
        <div class="row g-3 justify-content-center">
          <div class="col-6 col-sm-4 col-md-3" *ngFor="let img of chemistryImages">
            <div class="gallery-card rounded-4 overflow-hidden position-relative shadow-sm" (click)="openLightbox(img)">
              <img [src]="img" alt="Chemistry Lab Setup" class="img-fluid w-100" style="object-fit: cover; height: 180px; transition: transform 0.3s ease;">
              <div class="gallery-overlay d-flex align-items-center justify-content-center">
                <span class="zoom-icon"><i class="fas fa-search-plus"></i> View</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Home Science Lab Panel -->
      <div *ngIf="activeTab === 'homescience'" class="animate-fade-in">
        <div class="row g-4 mb-4">
          <div class="col-md-6">
            <h4 class="section-subtitle text-success mb-3">Cooking Lab</h4>
            <p class="inner-lead">
              This fully equipped lab is designed to provide hands-on training in culinary arts, meal planning, and nutrition. Students learn commercial food presentation, diet planning for diverse age groups, and high standards of food safety and hygiene.
            </p>
          </div>
          <div class="col-md-6">
            <h4 class="section-subtitle text-success mb-3">Home Management Lab</h4>
            <p class="inner-lead">
              Focused on creative arts and crafts, this lab supports activities such as stitching, fabric painting, interior decoration, and resource management. It is a dynamic studio where students acquire vital management, aesthetic design, and textile skills.
            </p>
          </div>
        </div>
        <div class="row g-3 justify-content-center">
          <div class="col-6 col-sm-4 col-md-3" *ngFor="let img of homeScienceImages">
            <div class="gallery-card rounded-4 overflow-hidden position-relative shadow-sm" (click)="openLightbox(img)">
              <img [src]="img" alt="Home Science Lab Activity" class="img-fluid w-100" style="object-fit: cover; height: 180px; transition: transform 0.3s ease;">
              <div class="gallery-overlay d-flex align-items-center justify-content-center">
                <span class="zoom-icon"><i class="fas fa-search-plus"></i> View</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Fullscreen Backdrop-Blurred Lightbox -->
    <div class="lightbox-backdrop d-flex align-items-center justify-content-center animate-fade-in" *ngIf="activeLightboxImage" (click)="closeLightbox()">
      <div class="lightbox-content position-relative" (click)="$event.stopPropagation()">
        <button class="btn-close-lightbox" (click)="closeLightbox()">&times;</button>
        <img [src]="activeLightboxImage" class="lightbox-img img-fluid rounded-3" alt="Fullscreen Science Lab View">
      </div>
    </div>

    <div class="mt-5 text-center">
       <p class="text-muted small"><em>Providing standard scientific learning facilities to foster academic greatness.</em></p>
    </div>

  </div>
</div>

